export default __webpack_public_path__ + "static/media/josh_raxlen.fd88dd38.webp";